export const THEME_TOGGLE = 'theme.toggle';
export const THEME_SET_DARK = 'theme.set-dark';
export const THEME_SET_LIGHT = 'theme.set-light';

export const THEME_SET_MOBILE_VERSION = 'theme.set-mobile-version';
export const THEME_SET_DESKTOP_VERSION = 'theme.set-desktop-version';

export const THEME_OPEN_MOBILE_SIDEBAR = 'theme.open-mobile-sidebar';
export const THEME_CLOSE_MOBILE_SIDEBAR = 'theme.close-mobile-sidebar';
export const THEME_TOGGLE_MOBILE_SIDEBAR = 'theme.toggle-mobile-sidebar';

export const THEME_TOGGLE_SIDEBAR_SIZE = 'theme.toggle-sidebar-size';
export const THEME_SET_SMALL_SIDEBAR_SIZE = 'theme.set-small-sidebar-size';
export const THEME_SET_BIG_SIDEBAR_SIZE = 'theme.set-big-sidebar-size';
